import { render, staticRenderFns } from "./RegisterRiderInfo.vue?vue&type=template&id=98f057b8&scoped=true"
import script from "./RegisterRiderInfo.vue?vue&type=script&lang=js"
export * from "./RegisterRiderInfo.vue?vue&type=script&lang=js"
import style0 from "./RegisterRiderInfo.vue?vue&type=style&index=0&id=98f057b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f057b8",
  null
  
)

export default component.exports